import styled from "styled-components";
import { theme } from "../../../../../helpers/theme";
//import { ReactComponent as DedicatedWarehouseSVG } from "../../../../../assets/icons/warehouse-dedicated.svg";
import Icon from "../../../../../components/icon";
import { ReactComponent as ThickSVG } from "../../../../../assets/icons/thick.svg";

export const getAKindOfPackage = (type: number) => {
  switch (type) {
    case 0:
      return "Carton";
    case 1:
      return "BigBag";
    case 2:
      return "Paleta EUR";
    case 3:
      return "Paleta 1/2 EUR";
    case 4:
      return "Other pallet,";
    case 5:
      return "Other";
  }
};
export const getLengthUnit = (type: number) => {
  switch (type) {
    case 0:
      return "m";
    case 1:
      return "cm";
    case 2:
      return "mm";
  }
};
export const getWeighthUnit = (type: number) => {
  switch (type) {
    case 0:
      return "kg";
    case 1:
      return "t";
    case 2:
      return "dkg";
  }
};

// const toMReducer = (type: number) => {
//   switch (type) {
//     case 0:
//       //m
//       return 1;
//     case 1:
//       //cm
//       return 1 / 10000;
//     case 2:
//       //mm
//       return 1 / 1000000;
//   }
// };

// const toTReducer = (type: number) => {
//   switch (type) {
//     case 0:
//       //kg
//       return 1000;
//     case 1:
//       //t
//       return 1;
//     case 2:
//       //dkg
//       return 100000;
//   }
// };

export type PropertyQuantumDetailOrderItem = {
  dlugosc: number;
  dodatkowe_informacje: string;
  id_przedmiot_skladowania: number;
  ilosc: number;
  jednostka_dlugosci: number;
  jednostka_wagi: number;
  rodzaj_opakowania: number;
  rozmiar: number;
  szerokosc: number;
  waga: number;
  wysokosc: number;
};

interface SummaryProps {
  data: PropertyQuantumDetailOrderItem[];
}

export const QuantumDetailOrder = (props: SummaryProps) => {
  return (
    <>
      {props.data?.map((property) => (
        <SinglePropertySummaryWraper
          key={getAKindOfPackage(property.rodzaj_opakowania)}
        >
          <SummaryItemName>
            <Icon height="20px" width="20px" noPadding icon={<ThickSVG />} />
            <Title>{getAKindOfPackage(property.rodzaj_opakowania)}</Title>
          </SummaryItemName>
          <Wraper>
            <DefinitionWraper>
              <SummaryItemValue>
                <Size>
                  Szerokość: {property.szerokosc}
                  <Utils> {getLengthUnit(property.jednostka_dlugosci)}</Utils>,
                </Size>
                <Size>
                  Długość: {property.dlugosc}
                  <Utils> {getLengthUnit(property.jednostka_dlugosci)}</Utils>,
                </Size>
                <Size>
                  Wysokość: {property.wysokosc}
                  <Utils> {getLengthUnit(property.jednostka_dlugosci)}</Utils>,
                </Size>
                {/* <Size>
                  Waga: {property.waga}
                  <Utils> {getWeighthUnit(property.jednostka_wagi)}/szt.</Utils>
                </Size> */}
              </SummaryItemValue>
            </DefinitionWraper>
            <DefinitionWraper>
              <SummaryNumber>
                <div>Ilość: </div>
                <Active>
                  <div>
                    {property.ilosc}
                    <Utils> szt.</Utils>
                  </div>
                </Active>
              </SummaryNumber>
              <SummaryArea>
                <div>Powierzchnia: </div>
                <Active>
                  <div>
                    {/* //Wymiar wysylany w m i tak zostawiony :?*/}

                    {Number(property.rozmiar).toFixed(2)}

                    {/* {((Math.round(property.rozmiar * Number(toMReducer(property.jednostka_dlugosci))) * 100) / 100).toFixed(2)} */}

                    <Utils>
                      {" "}
                      {/* {getLengthUnit(property.jednostka_dlugosci)} 
                      //Jednostka poniżej wpisana na sztywno bo w m jest wysyłana wartosć*/}
                      {getLengthUnit(0)}
                      <sup>2</sup>
                    </Utils>
                  </div>
                </Active>
              </SummaryArea>
              <SummaryWeight>
                <div>Waga łączna:</div>
                <Active>
                  <div>
                    {/* {property.waga * property.ilosc} */}
                    {/* //Waga wpisana na sztywno że w t :/ */}

                    {(
                      (Number(property.waga) * Number(property.ilosc)) /
                      1000
                    ).toFixed(2)}
                    {/* {((Math.round(property.waga * Number(toMReducer(property.jednostka_wagi))) * 100) / 100).toFixed(2)} */}
                    <Utils>
                      {" "}
                      {/* {getWeighthUnit(property.jednostka_wagi)} */}
                      {getWeighthUnit(1)}
                    </Utils>
                  </div>
                </Active>
              </SummaryWeight>
              <SummaryWeight style={{marginBottom:"10px"}}>
                <div>Waga jednostkowa:</div>
                <Active>
                  <div>
                      {Number(property.waga).toFixed(2)}

                      <Utils> {getWeighthUnit(property.jednostka_wagi)}/szt.</Utils>
                  </div>
                </Active>
              </SummaryWeight>
            </DefinitionWraper>
          </Wraper>
        </SinglePropertySummaryWraper>
      ))}
    </>
  );
};
const SinglePropertySummaryWraper = styled.div`
  padding-top: 16px;
`;
const Wraper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: top;
  @media (min-width: 450px) {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

const DefinitionWraper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: 450px) {
    width: 50%;
    max-width: 300px;
  }
`;
const SummaryItemName = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
  width: 100%;
`;
const Title = styled.div`
  padding-left: 14px;
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.normal};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.black_primaryText};
`;
const SummaryItemValue = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
`;
const Size = styled.div`
  padding: 0px 30px;
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.normal};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.gray01_secondaryText};
  white-space: nowrap;
`;
const Utils = styled.span``;

const SummaryNumber = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${theme.colors.gray01_secondaryText};
  font-family: ${theme.fonts.interRegular};
  font-size: 14px;
  line-height: 20px;
  @media (max-width: 450px) {
    padding: 30px 30px 0px 30px;
  }
`;
const SummaryArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${theme.colors.gray01_secondaryText};
  font-family: ${theme.fonts.interRegular};
  font-size: 14px;
  line-height: 20px;
  @media (max-width: 450px) {
    padding: 0px 30px;
  }
`;
const SummaryWeight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${theme.colors.gray01_secondaryText};
  font-family: ${theme.fonts.interRegular};
  font-size: 14px;
  line-height: 20px;
  @media (max-width: 450px) {
    padding: 0px 30px;
  }
`;
const Active = styled.div`
  color: ${theme.colors.black_primaryText};
`;
